import { useContext, useEffect } from "react";
import PageContext from "../global_state/context/PageContext";
import { loggedUserPages, PageI, PageType, PopUpType } from "../types/PageI";
import CreateAccount from "./create_account/CreateAccount";
import VerifyEmail from "./create_account/VerifyEmail";
import CreateOnlineAccount from "./create_online_account/CreateOnlineAccount";
import CreatePassword from "./create_online_account/CreatePassword";
import EmailNotFound from "./emails/EmailNotFound";
import EmailSend from "./emails/EmailSend";
import EntrancePage from "./EntrancePage";
import LogInForm from "./LogInForm";
import Memberships from "./Memberships";
import Reservations from "./Reservations";
import UserHeader from "./UserHeader";
import UserProfile from "./UserProfile";

import SCSS from 'assets/scss/App.module.scss'
import Eshop from "./eshop/Eshop";
import ForgottenPassword from "./forgotten_password/ForgottenPassword";

import ResetPassword from "./forgotten_password/ResetPassword";
import Lessons from "./lessons/Lessons";
import { getUser } from "services/user_services/GetUser";
import { PaymentsType } from "types/PaymentsI";
import { verifyHashService } from "services/VerifyHash";
import Notifications from "./notifications/Notifications";
import BuyMembershipPopUp from "./pop-ups/BuyMemberhipPopUp";
import BuyCreditPopUp from "./pop-ups/BuyCreditPopUp";
import CreditHistory from "./CreditHistory";
import AccountDetail from "./AccountDetail";
import { addPageListener, addUserLogoutListener, removePageListener, removeUserLogoutListener } from "services/eventFunctions";
import UserContext from "global_state/context/UserContext";
import { UserI } from "types/UserI";

const renderPage = (page: PageI, user:UserI) => {  

    switch(page.type) {
      case (PageType.account_detail): {
        return (
          <>
            <UserHeader/>
            <AccountDetail/>
          </>
        )
      }
      case (PageType.user_profile): {
        return(
          <>
            <UserHeader/>
            <UserProfile/>
          </>
          
        )
      } 
      case (PageType.log_in_form): {
        return (
          <LogInForm {...page.props}/>        
        )
      }
      case (PageType.create_account): {
        return (
          <CreateAccount/>
        )
      }
      case (PageType.create_online_account): {
        return (
          <CreateOnlineAccount/>
        )
      }
      case (PageType.email_send): {
        return (
          <EmailSend {...page.props}/>
        )
      }
      case (PageType.email_not_found): {
        return (
          <EmailNotFound {...page.props}/>
        )
      }
      case (PageType.create_password): {
        return (
          <CreatePassword/>
        )
      }
      case (PageType.verify_email): {
        return (
          <VerifyEmail {...page.props} />
        )
      }
      case (PageType.forgotton_password): {
        return (
          <ForgottenPassword/>
        )
      }
      case (PageType.reset_password): {
        return (
          <ResetPassword/>
        )
      }
      case (PageType.memberships): {
        return (
          <>
            <UserHeader/>
            <Memberships/>
          </>
          
        )
      }
      case (PageType.reservations): {
        return (
          <>
            <UserHeader/>
            <Reservations/>
          </>
        )
      }
      case (PageType.ehsop): {
        return (
          <>
            <UserHeader/>
            <Eshop/>
          </>
        )
      }
      case (PageType.credit_history): {
        return (
          <>
            <UserHeader/>
            <CreditHistory/>
          </>
        )
      }
      case (PageType.lessons): {
        return (
          <>
            <UserHeader/>
            <Lessons/>
          </>
        )
      }
      default:
        return (
          <EntrancePage/>
        );
    } 
}
const renderNotifications = () => {
  return (
    <Notifications/>
  )
}
const renderPopUp = (page: PageI) => {
  // let html = document.getElementsByTagName('html')  
  // console.log(page.popup);
  
  switch(page.popup) {
    case (PopUpType.buy_membership): {
      // html[0].style.position = 'fixed'
      return (
        <div className={SCSS.popup_wrapper} >
          <BuyMembershipPopUp {...page.props}/>
        </div>
        
      )
    }
    case (PopUpType.buy_credits): {
      // html[0].style.position = 'fixed'
      return (
        <div className={SCSS.popup_wrapper} >
          <BuyCreditPopUp {...page.props}/>
        </div>
      )
    }
    default: {
      // html[0].style.position = 'initial'
      return null
    }
  }
}


function PageRouter() {
  
  const {page, dispatchPage}  = useContext(PageContext)
  const {user, dispatchUser} = useContext(UserContext)

  const verifyEmailFromHash = async (search_params: URLSearchParams) => {
    // console.log("verify Email From Hash".toUpperCase());
    // console.log(search_params);
    
    if (!search_params.has('verify')) {
      return 
    }

    const verify_hash = search_params.get("verify");
    if (verify_hash == null) {
      return 
    }

    const verify_type = search_params.get("type");      
    let response =  await verifyHashService(verify_hash, verify_type)
    
    /** ERROR */
    if (typeof response === 'string') {
      dispatchPage({
        type: "add_notification",
        payload: {
          notification: {
            type: "error",
            message: response
          }
        }
      })
      return 
    }

    /** set User and Page after email wsa verified */
    dispatchUser({type: "update_client_id", payload: {client_id: response.user}})
    dispatchPage({type: "render", payload: {page: response.page}})

    /** remove verify and type from search_params in URL */
    let history_state = window.history.state
    
    search_params.delete("verify")
    search_params.delete("type")
    
    // console.log("after deleted".toUpperCase());
    // console.log(search_params);
    
    window.history.replaceState(history_state, '', '?' + search_params.toString())

    // window.history.pushState("", "",window.location.href.split('?')[0]);

    

  }
  const processPayment = async (search_params: URLSearchParams) => {
    if (!search_params.has('id') || !search_params.has('payment_type')) {
      return 
    }
    
    const payment_id = search_params.get("id");
    const payment_type = search_params.get("payment_type");
    search_params.delete("id")
    search_params.delete("payment_type")

    if (payment_id == null || payment_type == null) {
      return 
    }

    if (payment_type === PaymentsType.credits) {        
      dispatchPage({
        type: "add_notification",
        payload: {
            notification: {
                type: "success",
                message: "credit_added_success"
            }
        }
      }) 
      let user = await getUser()
      dispatchUser({type: "update_user_credits", payload: user})
    }

    if (payment_type === PaymentsType.memberships) {
      const membership_id = search_params.get("memberships");
      search_params.delete("memberships")

      dispatchPage({
        type: "add_notification",
        payload: {
            notification: {
                type: "success",
                message: "memberships_added_success"
            }
        }
      }) 
    }
    
    if (search_params.has('client_id')) {
      search_params.delete('client_id')
    }

    let history_state = window.history.state
    window.history.replaceState(history_state, "", '?' + search_params);
  }
  const processResetPassword = async (search_params: URLSearchParams) => {
    // console.log("process Reset Password".toUpperCase());
    // console.log(search_params);
    
    /** if not request to reset password then skip  */ 
    if (!search_params.has('reset_password')) {
      /** loading reset password form without request */
      if (page.type == PageType.reset_password) {
        // console.log("HERE");
        
        dispatchPage({
          type: "render",
          payload: {
            page: PageType.entrance
          }
        })
      }
      return 
    }

    /** show form for reset password */
    dispatchPage({
      type: "render",
      payload: {
        page: PageType.reset_password
      }
    })
    
    /** remove reset_password after the request is sent to server*/
  }

  const handleSearchParams = async () => {
    // console.log("handle Search Params".toUpperCase());
    
    let search_params = new URLSearchParams(window.location.search)
    await verifyEmailFromHash(search_params)
    await processPayment(search_params)
    await processResetPassword(search_params)
  }
  const redirectNotLoggedUser = () => {
    
    /** if not logged user - set page to entry with exception */
  // console.log("redirect not logged user".toUpperCase());
  // console.log(user.client_id);
  // console.log(page.type);
  // console.log(loggedUserPages.includes(page.type));
    
    
    if ((user.client_id == null || user.client_id == undefined) && loggedUserPages.includes(page.type)) {
      
      let url_search_params = new URLSearchParams(window.location.search) 
      url_search_params.set('xf_page', PageType.entrance)
      let id = Date.now().toString();
      window.history.pushState(
        {
            "id": id,
            "xf_page": PageType.entrance
        }, 
        '', 
        "?" + url_search_params.toString()
      );
      
      dispatchPage({
        type: "render", 
        payload: {
          page: PageType.entrance
        }
      })

    }
  }
  const handlePopstate = (event) => {
    
    let page = (event.state !== null) ? event.state?.xf_page || 'entrance' : 'user_profile'
      
    dispatchPage({
      type: "render", 
      payload: {
        page: page,
        popstate: true
      }
    })

    // redirectNotLoggedUser()

  }

  useEffect(() => {
    // TODO: if first render, load add modify url, do not push new state
    
    handleSearchParams()
    
    /** comunication with header components */
    addPageListener(dispatchPage)
    addUserLogoutListener(user, dispatchUser, dispatchPage)
    
    /** to block wordpress theme scrolling */
    window.scrollTo(0, 0);

    /** react on the back and forward browser buttons */
    window.addEventListener('popstate', handlePopstate);

    redirectNotLoggedUser()

    return () => {
      removePageListener(dispatchPage)
      removeUserLogoutListener(user, dispatchUser, dispatchPage)
      window.removeEventListener('popstate', handlePopstate);
    }
  }, []) 

  return (
    <>
      <main className={SCSS.app_main}>
        {renderNotifications()}
        {renderPage(page, user)}
      </main>
      {renderPopUp(page)}
    </>
  )
}

export default PageRouter